import React from 'react'
import {
  DomainReactivationListRow,
  DomainReactivationListRowDomainWrapper,
  DomainReactivationListRowText,
  DomainReactivationListWrapper,
  DomainReactivationSelectProductWrapper,
} from 'Features/ReactivationPage/DomainReactivationModal/DomainReactivationModal.styled'
import { CheckBox } from '@clickcease/cc-client-components-lib'
import { SelectProduct } from 'Components/Elements/AddDomainModal/features/SelectProduct'
import { ReactivateDomains } from 'Types/Domain'

type DomainReactivationListProps = {
  domains: Array<ReactivateDomains>
  selectDomain: (index: number) => void
  selectDomainProduct: (domainId: number, paidMarketing: boolean, botZapping: boolean) => void
}

export const DomainReactivationListRows = ({
  domains,
  selectDomain,
  selectDomainProduct,
}: DomainReactivationListProps) => {
  return (
    <DomainReactivationListWrapper>
      {domains?.map((domain) =>
        domain.showInSearch ? (
          <DomainReactivationListRow key={domain.id}>
            <DomainReactivationListRowDomainWrapper>
              <CheckBox
                containerCSS={{ marginTop: '21px' }}
                isChecked={domain.selected}
                onClick={() => {
                  selectDomain(domain.id)
                }}
                disabled={false}
              />
              <DomainReactivationListRowText>{domain.address}</DomainReactivationListRowText>
            </DomainReactivationListRowDomainWrapper>
            <DomainReactivationSelectProductWrapper>
              <SelectProduct
                onSelect={(options) => {
                  selectDomainProduct(
                    domain.id,
                    options.paidMarketing || false,
                    options.botZapping || false
                  )
                }}
                selected={{ paidMarketing: domain.paidMarketing, botZapping: domain.botZapping }}
                showOnlySelect
              />
            </DomainReactivationSelectProductWrapper>
          </DomainReactivationListRow>
        ) : null
      )}
    </DomainReactivationListWrapper>
  )
}
